enum PrivacyRequestType {
  Delete = 0,
  Export = 1,
}

export default PrivacyRequestType;
